import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { ActionsCell } from "@/molecules/ActionsCell"

import type { UserActionsCellComponent } from "."

export const UserActionsCell: UserActionsCellComponent = ({
  deleteUser,
  resetOrResendPassword,
  editUser,
  t
}) => {
  const selfHosted = isSelfHosted()

  return function UserActionsCellComponent(_, record) {
    const { status } = record

    if (status === "DECLINED") return null

    const prefix = "settings.users.actions"
    const isInvited = status === "INVITED"
    let keyActionByStatus = isInvited ? "resend" : "reset"

    if (selfHosted && isInvited) keyActionByStatus = "regenerate"

    const items = [
      { key: "edit", label: t(`${prefix}.edit`) },
      { key: keyActionByStatus, label: t(`${prefix}.${keyActionByStatus}`) },
      { key: "delete", label: t(`${prefix}.delete`) }
    ]

    return (
      <ActionsCell
        items={items}
        onClick={({ key }) => {
          if (key === items[0].key) return editUser(record)
          if (key === items[2].key) return deleteUser(record)

          resetOrResendPassword(
            record,
            key === "resend" || key === "regenerate"
          )
        }}
      />
    )
  }
}
